module.exports = __webpack_public_path__ + "img/dan-survey-pad.49a8fdc0.jpg";